import { Box, DropdownOptions } from "dash-ui";

import ApiTabs from "./components/ApiTabs/ApiTabs";

const ApiManagementPage = () => (
  <Box w="100%">
    <DropdownOptions />
    <ApiTabs />
  </Box>
);

export default ApiManagementPage;
